import {
	getDisplayablePetitionPhoto,
	usePsfPromoteOrSharePageData,
} from '#src/app/pages/psf/promoteOrShare/pageContext';

type Result = ModelHookResult<{
	photo?: {
		url: string;
		mobileUrl: string;
	};
}>;

export function usePetitionMedia(): Result {
	const {
		data: {
			petition: { photo },
		},
	} = usePsfPromoteOrSharePageData();

	return {
		data: {
			photo: getDisplayablePetitionPhoto(photo),
		},
	};
}
